<h3>Payment Processors</h3>

<wm-payment-processor-list [processors]="processors">
</wm-payment-processor-list>
